import { useEffect, useMemo, useState } from "react"
import Dirs, { GDir } from "../fmanlibs/Dirs"
import Loading from "../libs/loading/Loading"
import TreeNode, { ITreeNode } from "../libs/tree/TreeNode"
import { usePath } from "../libs/path/PathProvider"
import TreeNodeSession from "../libs/tree/TreeNodeSession"

export default function(){
    const [root,setRoot] = useState<GDir>()
    const {path,setPath} = usePath()
    const [_,selectedId] = path.split("/")
    const refresh = () => Dirs.i.root.then(root => setRoot(root)) 
    const session = useMemo(() => root ? new TreeNodeSession(Dirs.i).open(selectedId, Dirs.i) : null, [root])

    useEffect(() => { 
        refresh()
        Dirs.i.on("cache", refresh)
        return () => { Dirs.i.removeListener("cache", refresh) }
    },[])

    useEffect(() => {
        session?.open(selectedId, Dirs.i)
    },[selectedId])

    const onChange = (node:ITreeNode<GDir>) => setPath(`/${node._id}`)
    return root ? <TreeNode className="tree" node={root} selectedId={selectedId||"0"} session={session} onChange={onChange}/> : <Loading className="m-16 self-top"/>
}